export default __webpack_public_path__ + "images/d12106e1119873bb88fb13cb5261ec01.png";